import { ProductType } from 'types/Products';
import CustomFilters from '../CustomFilters/CustomFilters';
import SearchFilters from './SearchFilters';
import { useContext } from 'react';
import { SearchContext } from 'context/SearchContext';
import { BrandPortalFilters } from '../CustomFilters/BrandPortalFilters';
import { UnionCustomAttributeProps } from 'components/common/Portals/CustomAttributes/types';
import { Box } from '@mui/material';
import { SegmentTag } from 'types/global';

interface Props {
  isBrandPortal: boolean;
  isLaPrairieEvent: boolean;
  companyAttributeDefinitions?: UnionCustomAttributeProps[];
  productAttributeDefinitions?: UnionCustomAttributeProps[];
}
export const Filters: React.FC<Props> = ({
  isLaPrairieEvent,
  isBrandPortal,
  companyAttributeDefinitions,
  productAttributeDefinitions
}) => {
  const { request, results, updateFilters } = useContext(SearchContext);
  return (
    <Box
      sx={{
        minHeight: 0,
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        overflow: isBrandPortal ? 'auto' : undefined
      }}
    >
      {isBrandPortal &&
        request.target === ProductType.INGREDIENTS &&
        isLaPrairieEvent && <CustomFilters />}
      {request.segment === SegmentTag.PERSONALCARE && (
        <BrandPortalFilters
          companyAttributeDefinitions={companyAttributeDefinitions}
          productAttributeDefinitions={productAttributeDefinitions}
        />
      )}
      <SearchFilters
        facets={results.facets}
        target={request.target}
        activeFilters={request.filters}
        updateFilters={updateFilters}
        isBrandPortal={isBrandPortal}
        segment={request.segment}
      />
    </Box>
  );
};
